import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNotifications } from '../contexts/NotificationContext';

import SearchModal from '../components/ModalSearch';
import Notifications from '../components/DropdownNotifications';
//import Help from '../components/DropdownHelp';
import UserMenu from '../components/DropdownProfile';
import ThemeToggle from '../components/ThemeToggle';

function Header({
  sidebarOpen,
  setSidebarOpen
}) {

  const [searchModalOpen, setSearchModalOpen] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { unreadMessages, notifications, markMessageAsRead } = useNotifications();

  return (
    <header className="sticky top-0 bg-white dark:bg-[#182235] border-b border-slate-200 dark:border-slate-700 z-30">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 -mb-px">

          {/* Header: Left side */}
          <div className="flex">

            {/* Hamburger button */}
            <button
              className="text-slate-500 hover:text-slate-600 lg:hidden"
              aria-controls="sidebar"
              aria-expanded={sidebarOpen}
              onClick={(e) => { e.stopPropagation(); setSidebarOpen(!sidebarOpen); }}
            >
              <span className="sr-only">Open sidebar</span>
              <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="5" width="16" height="2" />
                <rect x="4" y="11" width="16" height="2" />
                <rect x="4" y="17" width="16" height="2" />
              </svg>
            </button>

          </div>

          {/* Header: Right side */}
          <div className="flex items-center space-x-3">
            <div>
              <button
                className={`w-8 h-8 flex items-center justify-center bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600/80 rounded-full ml-3 ${searchModalOpen && 'bg-slate-200'}`}
                onClick={(e) => { e.stopPropagation(); setSearchModalOpen(true); }}
                aria-controls="search-modal"
              >
                <span className="sr-only">Search</span>
                <svg className="w-4 h-4" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                  <path className="fill-current text-slate-500 dark:text-slate-400" d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
                  <path className="fill-current text-slate-400 dark:text-slate-500" d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z" />
                </svg>
              </button>
              <SearchModal id="search-modal" searchId="search" modalOpen={searchModalOpen} setModalOpen={setSearchModalOpen} />
            </div>
            <div className="relative inline-flex ml-3">
              <Link
                to="/messages"
                className="w-8 h-8 flex items-center justify-center bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600/80 rounded-full"
              >
                <span className="sr-only">Messages</span>
                <svg className="w-4 h-4" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                  <path className="fill-current text-slate-500 dark:text-slate-400" d="M6.5 0C2.91 0 0 2.462 0 5.5c0 1.075.37 2.074 1 2.922V12l2.699-1.542A7.454 7.454 0 006.5 11c3.59 0 6.5-2.462 6.5-5.5S10.09 0 6.5 0z" />
                  <path className="fill-current text-slate-400 dark:text-slate-500" d="M16 9.5c0-.987-.429-1.897-1.147-2.639C14.124 10.348 10.66 13 6.5 13c-.103 0-.202-.018-.305-.021C7.231 13.617 8.556 14 10 14c.449 0 .886-.04 1.307-.11L15 16v-4h-.012C15.627 11.285 16 10.425 16 9.5z" />
                </svg>
                {unreadMessages > 0 && (
                  <div className="absolute top-0 right-0 w-2.5 h-2.5 bg-rose-500 border-2 border-white dark:border-slate-800 rounded-full"></div>
                )}
              </Link>
            </div>
            <div className="relative inline-flex ml-3">
              <button
                className="w-8 h-8 flex items-center justify-center bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600/80 rounded-full"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                aria-expanded={dropdownOpen}
              >
                <span className="sr-only">Notifications</span>
                <svg className="w-4 h-4" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                  <path className="fill-current text-slate-500 dark:text-slate-400" d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
                </svg>
                {notifications.filter(n => n.type !== 'message' && !n.read).length > 0 && (
                  <div className="absolute top-0 right-0 w-2.5 h-2.5 bg-rose-500 border-2 border-white dark:border-slate-800 rounded-full"></div>
                )}
              </button>
              
              {dropdownOpen && (
                <div className="origin-top-right z-10 absolute top-full right-0 -mr-48 sm:mr-0 min-w-[320px] bg-white dark:bg-slate-800 rounded-lg shadow-xl overflow-hidden mt-1 border border-slate-200/70 dark:border-slate-700/80">
                  <div className="bg-gradient-to-r from-slate-50 to-white dark:from-slate-800 dark:to-slate-800/80 px-4 py-3 border-b border-slate-200 dark:border-slate-700">
                    <div className="text-xs font-semibold tracking-wider text-slate-500 dark:text-slate-400 uppercase">
                      Notificaciones
                    </div>
                  </div>
                  <ul className="divide-y divide-slate-100 dark:divide-slate-700/50">
                    {notifications.filter(n => n.type !== 'message').length > 0 ? (
                      notifications.filter(n => n.type !== 'message').map(notification => (
                        <li key={notification.id}>
                          <Link
                            className={`block hover:bg-slate-50 dark:hover:bg-slate-700/20 transition-colors duration-150 ${
                              !notification.read ? 'bg-gradient-to-r from-indigo-50/40 to-transparent dark:from-indigo-500/5' : ''
                            }`}
                            to="#"
                            onClick={() => {
                              // Handle notification click logic
                            }}
                          >
                            <div className="px-4 py-3">
                              <div className="flex items-start justify-between">
                                <div className="space-y-0.5 flex-1">
                                  <div className="flex items-center justify-between">
                                    <span className="text-sm font-medium text-slate-900 dark:text-slate-100 flex items-center">
                                      {notification.title}
                                      {!notification.read && (
                                        <span className="ml-2 inline-flex items-center">
                                          <span className="w-1.5 h-1.5 bg-indigo-400 rounded-full"></span>
                                        </span>
                                      )}
                                    </span>
                                    <span className="text-xs font-medium text-slate-400 dark:text-slate-500 ml-2">
                                      {notification.timestamp.toLocaleTimeString([], {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                      })}
                                    </span>
                                  </div>
                                  <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
                                    {notification.subtitle}
                                  </p>
                                  <p className="text-xs leading-relaxed text-slate-600 dark:text-slate-300 line-clamp-2">
                                    {notification.message}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </li>
                      ))
                    ) : (
                      <li className="px-4 py-8">
                        <div className="text-center">
                          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-slate-50 dark:bg-slate-700/30 mb-3">
                            <svg className="w-6 h-6 text-slate-400 dark:text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                            </svg>
                          </div>
                          <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
                            No tiene notificaciones pendientes
                          </p>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </div>
            {/*<Help align="right" />*/}
            <ThemeToggle />
            {/*  Divider */}
            <hr className="w-px h-6 bg-slate-200 dark:bg-slate-700 border-none" />
            <UserMenu align="right" />

          </div>

        </div>
      </div>
    </header>
  );
}

export default Header;